import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import servicesData from '../data/servicesData'
import { getServiceIcon } from './ServiceIcons'
import '../styles/components/Services.css'

const Services = () => {
  const [hardwareExpanded, setHardwareExpanded] = useState(false)
  const navigate = useNavigate()

  return (
    <section id="services" className="services">
      <div className="services-container">
        {/* Header */}
        <div className="services-header">
          <span className="services-eyebrow">Our Services</span>
          <h2 className="services-title">
            Everything you need to <span className="title-highlight">grow digitally</span>
          </h2>
          <p className="services-intro">
            From brand identity to AI automation — we handle the tech so you can focus on your business.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {servicesData.map((service, index) => {
            const isHardware = service.id === 'hardware'
            const showExpandButton = isHardware && service.details.length > 7
            const visibleDetails = isHardware && !hardwareExpanded
              ? service.details.slice(0, 7)
              : service.details
            const hiddenCount = service.details.length - 7

            return (
              <div
                key={service.id}
                className={`service-card ${isHardware && hardwareExpanded ? 'expanded' : ''}`}
                style={{ '--card-color': service.color, cursor: 'pointer' }}
                onClick={() => service.externalLink ? window.open(service.externalLink, '_blank') : navigate(`/services/${service.linkTo || service.id}`)}
              >
                <div className="card-icon">
                  {getServiceIcon(service.id, '#fff')}
                </div>
                <h3 className="card-title">{service.title}</h3>
                <p className="card-description">{service.description}</p>

                <ul className="card-features">
                  {visibleDetails.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>

                {showExpandButton && (
                  <button
                    className="expand-button"
                    onClick={(e) => {
                      e.stopPropagation()
                      setHardwareExpanded(!hardwareExpanded)
                    }}
                  >
                    {hardwareExpanded ? (
                      <>Show less <span className="expand-icon">−</span></>
                    ) : (
                      <>+{hiddenCount} more <span className="expand-icon">+</span></>
                    )}
                  </button>
                )}

                <div className="card-buttons" onClick={(e) => e.stopPropagation()}>
                  {service.externalLink ? (
                    <a href={service.externalLink} target="_blank" rel="noopener noreferrer" className="card-button card-button-secondary">
                      Learn More
                      <span className="btn-arrow">→</span>
                    </a>
                  ) : (
                    <Link to={`/services/${service.linkTo || service.id}`} className="card-button card-button-secondary">
                      Learn More
                      <span className="btn-arrow">→</span>
                    </Link>
                  )}
                  <Link to={`/contact?service=${service.id}`} className="card-button">
                    Get Started
                    <span className="btn-arrow">→</span>
                  </Link>
                </div>
              </div>
            )
          })}
        </div>

        {/* Bottom CTA */}
        {/* <div className="services-cta">
          <p className="cta-text">Need something custom?</p>
          <Link to="/contact" className="cta-button">
            Let's talk about your project
            <span className="cta-arrow">→</span>
          </Link>
        </div> */}
      </div>
    </section>
  )
}

export default Services
